import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {InputNumber} from "primereact/inputnumber";
import {Button} from 'primereact/button';
import {BlockUI} from "primereact/blockui";
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import axios from "axios";
import Cookies from "js-cookie";
import currencyFormatter from "currency-formatter";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";
import {AutoComplete} from "primereact/autocomplete";
import moment from "moment/moment";
import {Message} from "primereact/message";
import {ConfirmDialog} from "primereact/confirmdialog";
import {ProgressBar} from "primereact/progressbar";
import {Tooltip} from "primereact/tooltip";
import {Fieldset} from "primereact/fieldset";
import {closeMercureSubscription, openMercureSubscription} from "../../util/mercure";

const _FM_FolioFormComponent = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {action, id} = useParams();
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [itemFormData, setItemFormData] = useState({
    folio: id,
  });
  const [itemNewFormData, setItemNewFormData] = useState({});
  const [items, setItems] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [chooseCustomer, setChooseCustomer] = useState(false);
  const [reservationGroups, setReservationGroups] = useState([]);
  const [reservation, setReservation] = useState({});
  const [accomodations, setAccomodations] = useState([]);
  const [services, setServices] = useState([]);
  const [ifa, setIfa] = useState({});
  const [ifas, setIfas] = useState([]);
  const [dialogIfa, setDialogIfa] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingPrices, setLoadingPrices] = useState(false);
  const [locking, setLocking] = useState(false);
  const formatQuantity = (quantity) => {
    const parsedQuantity = Number(quantity);
    return Number.isInteger(parsedQuantity) ? String(parsedQuantity) : parsedQuantity.toFixed(2);
  };

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      if (itemFormData.service && itemFormData.gross_amount && itemFormData.quantity) {
        axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio-item",
          {
            folio: Number(window.App.urlVars().folioId || id),
            unit_gross_amount: itemFormData.gross_amount,
            service: itemFormData.service,
            quantity: itemFormData.quantity,
          }, {
            params: {},
            headers: {
              'Authorization': 'Bearer ' + Cookies.get("userToken"),
              "Sys-name": Cookies.get("instanceId"),
              "Preferred-locale": Cookies.get("language")
            }
          })
          .then(response => {
            setItemFormData({
              ...itemFormData,
              gross_amount: null,
              service: null,
              quantity: 0,
            })
            setLoadingPrices(true)
            window.App.setState({
              rerenderFolioForm: Math.random(),
              rerenderFolioList: Math.random(),
            })
            window.App.toastShow('success', t('success'), response.data.message)
            axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio/" + formData.id,
              newFormData,
              {
                params: {},
                headers: {
                  'Authorization': 'Bearer ' + Cookies.get("userToken"),
                  "Sys-name": Cookies.get("instanceId"),
                  "Preferred-locale": Cookies.get("language")
                }
              })
              .then(response => {
                setFormData(response.data.data);
                setNewFormData({})
                setLoading(false)
                window.App.toastShow('success', t('success'), response.data.message)
                window.App.setState({
                  rerenderFolioList: Math.random(),
                  rerenderFolioDnd: Math.random(),
                })
                if (props.closeForm === true) {
                  navigate(-1)
                }
              })
              .catch(error => {
                setLoading(false)
                window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
              })
          })
          .catch(error => {
            setLoading(false)
            window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
          })
      } else {
        axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio/" + formData.id,
          newFormData,
          {
            params: {},
            headers: {
              'Authorization': 'Bearer ' + Cookies.get("userToken"),
              "Sys-name": Cookies.get("instanceId"),
              "Preferred-locale": Cookies.get("language")
            }
          })
          .then(response => {
            setFormData(response.data.data);
            setNewFormData({})
            setLoading(false)
            window.App.toastShow('success', t('success'), response.data.message)
            window.App.setState({
              rerenderFolioList: Math.random(),
              rerenderFolioDnd: Math.random(),
            })
            if (props.closeForm === true) {
              navigate(-1)
            }
          })
          .catch(error => {
            setLoading(false)
            window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
          })
      }

    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderFolioList: Math.random(),
            rerenderFolioDnd: Math.random(),
          })
          if (props.closeForm === true) {
            if (window.location.hash.toString().includes('#/folio/create') && window.App.urlVars().folioIds) {
              navigate('/folio/manage?folioIds=' + window.App.urlVars().folioIds + ',' + response.data.data.id)
            } else {
              navigate(-1)
            }
          } else {
            if (window.location.hash.toString().includes('#/folio')) {
              navigate(-1)
              setTimeout(() => {
                if (!window.App.urlVars().folioIds) {
                  navigate('/folio/update/' + response.data.data.id)
                } else {
                  navigate('/folio/manage?folioIds=' + window.App.urlVars().folioIds + ',' + response.data.data.id)
                }
              }, 500)
            }
            if (window.location.hash.toString().includes('#/customer')) {
              setTimeout(() => {
                navigate('/customer/' + action + '/' + id + '?update=folio&folioId=' + response.data.data.id)
              }, 500)
            }
            if (window.location.hash.toString().includes('#/reservation')) {
              setTimeout(() => {
                navigate('/reservation/' + action + '/' + id + '?update=folio&folioId=' + response.data.data.id)
              }, 500)
            }
            if (window.location.hash.toString().includes('#/calendar')) {
              setTimeout(() => {
                navigate('/calendar/' + action + '/' + id + '?update=folio&folioId=' + response.data.data.id)
              }, 500)
            }
            if (window.location.hash.toString().includes('#/control-panel')) {
              navigate(-1)
              setTimeout(() => {
                navigate('/control-panel?update=folio&folioId=' + response.data.data.id)
              }, 500)
            }
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  const priceReload = (folioID) => {
    const topic = process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.replace('/api', '')
      + Cookies.get("instanceId") + "/folio/" + folioID;
    const eventSource = openMercureSubscription({
      topics: [topic],
    });
    if (!eventSource) {
      return () => {};
    }
    console.log('feliratkozás történt: ' + topic)
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('push notification arrived:');
      console.log(data)
      setTimeout(() => {
        window.App.setState({
          rerenderFolioDnd: Math.random(),
          rerenderFolioForm: Math.random(),
          rerenderFolioList: Math.random()
        })
        setLoadingPrices(false)
      }, 500)
    }
    return () => {
      closeMercureSubscription(eventSource);
      console.log('leiratkozás történt: ' + topic)
    };
  }

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setAccomodations(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  useEffect(() => {
    if (formData.accommodation) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation-group?search[accommodation]=" + formData.accommodation,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setReservationGroups(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [formData.accommodation])

  useEffect(() => {
    let _sertviceFilter = ''
    if (formData.customer) {
      _sertviceFilter = 'search[available_for][operator]=!=&search[available_for][value]=reservation'
    }
    if (formData.reservation_group) {
      _sertviceFilter = 'search[available_for][operator]=!=&search[available_for][value]=customer'
    }
    if (formData.accommodation) {
      _sertviceFilter += "&search[accommodation][operator]=%3D&search[accommodation][value]=" + (formData.accommodation.id ?? formData.accommodation)
    }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service?" + _sertviceFilter,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setServices(response.data.data.items);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })

  }, [formData.customer, formData.reservation_group, formData.accommodation])

  useEffect(() => {
    if (window.App.urlVars().folioId || (id && id !== 'create' && window.App.urlVars().create !== 'folio')) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio/" + (window.App.urlVars().folioId ?? id),
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
          axios({
            method: 'get',
            url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio-item?search[folio][operator]=%3D&search[folio][value]=" + (window.App.urlVars().folioId ?? id),
            params: {},
            headers: {
              'Authorization': 'Bearer ' + Cookies.get("userToken"),
              "Sys-name": Cookies.get("instanceId"),
              "Preferred-locale": Cookies.get("language")
            }
          })
            .then(response => {
              setItems(response.data.data.items);
              setLoading(false)
            })
            .catch(error => {
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              setLoading(false)
            })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [window.App.state.rerenderFolioForm])

  useEffect(() => {
    if (Number(window.App.urlVars().accommodationId)) {
      setFormData((prev) => ({
        ...prev,
        accommodation: Number(window.App.urlVars().accommodationId),
      }));
    }
  }, [window.App.urlVars().accommodationId])

  useEffect(() => {
    if (loadingPrices === true && (window.App.urlVars().folioId ?? id)) {
      const cleanup = priceReload((window.App.urlVars().folioId ?? id));
      return () => {
        cleanup();
      };
    }
  }, [loadingPrices]);

  useEffect(() => {
    if (formData.customer && formData.customer.firstname) {
      setSelectedCustomer(formData.customer.lastname + ' ' + formData.customer.firstname + ' - ' + formData.customer.zip_code + ' ' + formData.customer.address)
    }
  }, [formData.customer]);

  useEffect(() => {
    if (props.customerId) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer/" + props.customerId,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setChooseCustomer(true)
          setFormData((prev) => ({
            ...prev,
            customer: Number(props.customerId),
          }));
          setSelectedCustomer(response.data.data.firstname + ' ' + response.data.data.lastname + ' - ' + response.data.data.zip_code + ' ' + response.data.data.address)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [props.customerId]);

  useEffect(() => {
    if (props.reservationId) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation/" + props.reservationId,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setChooseCustomer(false)
          setFormData((prev) => ({
            ...prev,
            reservation_group: Number(response.data.data?.reservation_group?.id),
            customer: null,
            accommodation: Number(
              response.data.data?.accommodation?.id ||
              response.data.data?.berth?.residential_unit?.accommodation?.id ||
              response.data.data?.residential_unit?.accommodation?.id
            ),
          }));
          setReservation(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [props.reservationId]);

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            {reservation && reservation.id &&
              <>
                <h2 className={"p-mb-0 p-text-normal"}>
                  {t('reservation')} <span className={"p-text-bold"}>
                  <span className={"tt-association-code-folio-form-info-" + reservation.id + " p-mr-2"}
                        data-pr-tooltip={reservation.association_code}>
                    <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                  </span>
                  <Tooltip target={".tt-association-code-folio-form-info-" + reservation.id}/>
                  <span className={"p-badge"}
                        style={{
                          fontSize: '1rem',
                          backgroundColor: reservation?.status
                            ? reservation?.status?.toLowerCase() === 'pending'
                              ? '#dddddd'
                              : reservation?.status?.toLowerCase() === 'confirmed'
                                ? '#f1eea5'
                                : reservation?.status?.toLowerCase() === 'cancelled'
                                  ? '#f7a2a2'
                                  : reservation?.status?.toLowerCase() === 'checked_in'
                                    ? '#3ec0e9'
                                    : reservation?.status?.toLowerCase() === 'checked_out'
                                      ? '#0abb87'
                                      : reservation?.status?.toLowerCase() === 'no_show'
                                        ? '#8a2be2'
                                        : '#ccc'
                            : undefined,
                          color: reservation?.status
                            ? reservation?.status?.toLowerCase() === 'pending' || reservation?.status?.toLowerCase() === 'confirmed'
                              ? '#5f656b'
                              : reservation?.status?.toLowerCase() === 'no_show'
                                ? '#fff'
                                : undefined
                            : undefined
                  }}>
                    {reservation?.association_code?.split(' | ').pop()?.trim()}
                  </span>
                </span> {t('folio_form').toLowerCase()}
                  <span style={{float: 'right', fontSize: '1rem'}} className={"p-text-normal p-mt-1"}>
                  #{reservation.id}
                </span>
                </h2>
                <div className={"p-grid"} style={{clear: 'both'}}>
                  <div className={"p-col"}>
                    <small className={"p-text-uppercase"}>
                      {t('reserved_from')}
                    </small>
                    <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                      {moment.utc(reservation.reserved_from).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                    </p>
                  </div>
                  <div className={"p-col"}>
                    <small className={"p-text-uppercase"}>
                      {t('reserved_to')}
                    </small>
                    <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                      {moment.utc(reservation.reserved_to).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                    </p>
                  </div>
                  <div className={"p-col p-text-right p-col-align-center"}>

                  </div>
                </div>
              </>
            }
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('folio_form')}</h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
              <span>
                <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
              </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className="p-col-12 p-lg-4">
                  <Field name="currency" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="currency"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>
                        {t('accommodation')}
                      </label>
                      <span className="p-d-block">
                            <Dropdown  options={accomodations}
                                      filter
                                      optionLabel="name"
                                      optionValue="id"
                                      id={"accommodation"}
                                      disabled={window.App.urlVars().accommodationId}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          accommodation: e.value,
                                          reservation_group: null,
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          accommodation: e.value,
                                          reservation_group: null,
                                        })
                                      }}
                                      value={formData?.accommodation?.id || formData.accommodation}
                            />
                          </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-8"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"name"}/>
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
              {(id && id !== '0' || window.App.urlVars().folioId) &&
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-4"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="net_amount">{t('net_amount')}</label>
                      <span className="p-d-block p-text-bold">
                        {loadingPrices ? (
                          <i className="pi pi-spin pi-spinner" style={{fontSize: '1rem'}}></i>
                        ) : (
                          <>
                            {currencyFormatter.format(
                              formData.net_amount, {
                                precision: t('currency_precision'),
                                symbol: t('currency_symbol'),
                                decimal: t('currency_decimal'),
                                thousand: t('currency_thousand'),
                              }
                            )}
                            &nbsp;
                            {(() => {
                              let _accommodation = accomodations.filter(item => item.id === (formData?.accommodation?.id ?? formData.accommodation))[0]
                              return _accommodation?.currency_code
                            })()}
                          </>
                        )}
                    </span>
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-4"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="vat">{t('vat')}</label>
                      <span className="p-d-block p-text-bold">
                        {loadingPrices ? (
                          <i className="pi pi-spin pi-spinner" style={{fontSize: '1rem'}}></i>
                        ) : (
                          <>
                            {currencyFormatter.format(
                              formData.vat_amount, {
                                precision: t('currency_precision'),
                                symbol: t('currency_symbol'),
                                decimal: t('currency_decimal'),
                                thousand: t('currency_thousand'),
                              }
                            )}
                            &nbsp;
                            {(() => {
                              let _accommodation = accomodations.filter(item => item.id === (formData?.accommodation?.id ?? formData.accommodation))[0]
                              return _accommodation?.currency_code
                            })()}
                          </>
                        )}
                    </span>
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-4"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="gross_amount">{t('gross_amount')}</label>
                      <span className="p-d-block p-text-bold">
                        {loadingPrices ? (
                          <i className="pi pi-spin pi-spinner" style={{fontSize: '1rem'}}></i>
                        ) : (
                          <>
                            {currencyFormatter.format(
                              formData.gross_amount, {
                                precision: t('currency_precision'),
                                symbol: t('currency_symbol'),
                                decimal: t('currency_decimal'),
                                thousand: t('currency_thousand'),
                              }
                            )}
                            &nbsp;
                            {(() => {
                              let _accommodation = accomodations.filter(item => item.id === (formData?.accommodation?.id ?? formData.accommodation))[0]
                              return _accommodation?.currency_code
                            })()}
                          </>
                        )}
                    </span>
                    </div>
                  </div>
                </div>
              }
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-12"}>
                  <Field name="description" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"description"}/>
                      <label htmlFor="description"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('description')}</label>
                      <span className="p-d-block">
                      <InputText id="description" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     description: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     description: e.target.value
                                   })
                                 }}
                                 value={formData.description}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                {!formData?.id && !chooseCustomer &&
                  <div className="p-col-12 p-lg-4">
                    <Field name="reservation_group" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="reservation_group"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>
                          {t('reservation_group')}
                        </label>
                        <span className="p-inputgroup">
                          <Dropdown  options={reservationGroups}
                                    filter
                                    disabled={!formData.accommodation}
                                    optionLabel="public_id"
                                    optionValue="id"
                                    id={"reservation_group"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setSelectedCustomer(null)
                                      setFormData({
                                        ...formData,
                                        reservation_group: e.value,
                                        customer: null
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        reservation_group: e.value,
                                        customer: null
                                      })
                                    }}
                                    value={formData?.reservation_group?.id || formData.reservation_group}
                          />
                          <Button type="button"
                                  label={t('choose_customer')}
                                  className="p-button-secondary"
                                  onClick={() => {
                                    setChooseCustomer(true)
                                    setFormData({
                                      ...formData,
                                      reservation_group: null,
                                      customer: null
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      reservation_group: null,
                                      customer: null
                                    })
                                  }}
                          />
                        </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                }
                {!formData?.id && chooseCustomer &&
                  <div className="p-col-12 p-lg-4">
                    <Field name="customer" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="customer"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>
                          {t('customer')}
                        </label>
                        <span className="p-inputgroup">
                          <AutoComplete value={selectedCustomer}
                                        id={"partner"}
                                        suggestions={customers}
                                        forceSelection
                                        dropdown
                                        completeMethod={(e) => {
                                          axios({
                                            method: 'get',
                                            url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
                                              + "customer??direction=desc&item_per_page=9999&search[firstname%2Blastname][operator]=like&search[firstname%2Blastname][value]=*"
                                              + e.query + "*&sort=id",
                                            params: {},
                                            headers: {
                                              'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                              "Sys-name": Cookies.get("instanceId"),
                                              "Preferred-locale": Cookies.get("language")
                                            }
                                          })
                                            .then(response => {
                                              if (response.data.data.items && response.data.data.items[0]) {
                                                let _customers = []
                                                response.data.data.items.map((customer) => {
                                                  if (customer.firstname && customer.zip_code && customer.address) {
                                                    _customers.push({
                                                      id: customer.id,
                                                      name: customer.lastname + ' ' + customer.firstname + ' - ' + customer.zip_code + ' ' + customer.address,
                                                    })
                                                  }
                                                  if (customer.firstname && !customer.zip_code && !customer.address) {
                                                    _customers.push({
                                                      id: customer.id,
                                                      name: customer.firstname,
                                                    })
                                                  }
                                                  if (!customer.firstname && !customer.zip_code && !customer.address) {
                                                    _customers.push({
                                                      id: customer.id,
                                                      name: customer.id,
                                                    })
                                                  }
                                                })
                                                setCustomers(_customers);
                                              } else {
                                                setSelectedCustomer(t('no_results_found'))
                                                setCustomers([])
                                              }
                                            })
                                            .catch(error => {
                                              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                            })
                                        }}
                                        field={"name"}
                                        delay="1000"
                                        placeholder={t('type_to_search')}
                                        onSelect={(e) => {
                                          setSelectedCustomer(e.value?.name || '')
                                          setFormData({
                                            ...formData,
                                            customer: e.value.id,
                                            reservation_group: null
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            customer: e.value.id,
                                            reservation_group: null
                                          })
                                        }}
                                        onChange={(e) => {
                                          setSelectedCustomer(e.value)
                                        }}
                                        onClear={(e) => {
                                          setSelectedCustomer(e.value)
                                          setFormData({
                                            ...formData,
                                            customer: null,
                                            reservation_group: null
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            customer: null,
                                            reservation_group: null
                                          })
                                        }}
                          />
                          <Button type="button"
                                  label={t('reservation_group')}
                                  className="p-button-secondary"
                                  onClick={() => {
                                    setChooseCustomer(false)
                                    setSelectedCustomer(null)
                                    setFormData({
                                      ...formData,
                                      customer: null,
                                      reservation_group: null
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      customer: null,
                                      reservation_group: null
                                    })
                                  }}
                          />
                        </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                }
                {formData?.id &&
                  <div className="p-col-12 p-lg-4">
                    <div className="p-field p-fluid">
                      <label htmlFor="folio_relation">
                        {Boolean(formData?.reservation_group?.id || formData.reservation_group) ? t('reservation_group') : t('customer')}
                      </label>
                      <span className="p-d-block">
                        {Boolean(formData?.reservation_group?.id || formData.reservation_group) ? (
                          <Dropdown options={[{
                            id: formData?.reservation_group?.id || formData.reservation_group,
                            public_id: formData?.reservation_group?.public_id || formData?.reservation_group?.id || formData.reservation_group
                          }]}
                                    optionLabel="public_id"
                                    optionValue="id"
                                    id={"folio_relation"}
                                    value={formData?.reservation_group?.id || formData.reservation_group}
                                    disabled
                           />
                        ) : (
                          <Dropdown options={[{
                            id: formData?.customer?.id || formData.customer,
                            name: formData?.customer?.firstname
                              ? `${formData.customer.lastname || ''} ${formData.customer.firstname} - ${formData.customer.zip_code || ''} ${formData.customer.address || ''}`.trim()
                              : selectedCustomer || formData?.customer?.id || formData.customer
                          }]}
                                    optionLabel="name"
                                    optionValue="id"
                                    id={"folio_relation"}
                                    value={formData?.customer?.id || formData.customer}
                                    disabled
                           />
                        )}
                      </span>
                    </div>
                  </div>
                }

              </div>
            </Panel>
          </form>
        )}/>
        <BlockUI blocked={!formData.id} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
          <Panel className={"p-mt-3"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                <h3 className={"p-my-0"}>
                  {t('folio_items')}
                </h3>
              </div>
              {formData.include_tourist_tax !== true &&
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>
                  {/*{loadingPrices &&*/}
                  {/*  <ProgressBar mode="indeterminate"*/}
                  {/*               style={{height: '5px', position: 'fixed', top: 0, zIndex: 9}}></ProgressBar>*/}
                  {/*}*/}
                  {/*<Button icon="pi pi-users" className="p-button-sm p-button-secondary p-ml-2"*/}
                  {/*        tooltip={t('ifa_calculate_and_add')}*/}
                  {/*        loading={loadingPrices}*/}
                  {/*        label={t('ifa_calculate_and_add')}*/}
                  {/*        tooltipOptions={{position: 'left'}}*/}
                  {/*        onClick={() => {*/}
                  {/*          window.App.setState({[`confirmIFA${id}`]: true})*/}
                  {/*        }}/>*/}
                  {/*<ConfirmDialog group="declarative" visible={window.App.state[`confirmIFA${id}`]}*/}
                  {/*               acceptLabel={t('yes')} rejectLabel={t('no')}*/}
                  {/*               onHide={() => {*/}
                  {/*                 window.App.setState({[`confirmIFA${id}`]: false})*/}
                  {/*               }}*/}
                  {/*               message={t('confirm_ifa_add_and_save_text')} header={t('confirm_ifa_add_and_save')}*/}
                  {/*               icon="pi pi-exclamation-triangle"*/}
                  {/*               accept={() => {*/}
                  {/*                 setLoading(true)*/}
                  {/*                 apiCall('get', 'folio/calc-ifa/' + (window.App.urlVars().folioId ?? id))*/}
                  {/*                   .then(response => {*/}
                  {/*                     setLoading(false)*/}
                  {/*                     if (response.data.data && response.data.data[0]) {*/}
                  {/*                       let ifasL = response.data.data.length - 1*/}
                  {/*                       response.data.data.map((item, index) => {*/}
                  {/*                         axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio-item",*/}
                  {/*                           {*/}
                  {/*                             folio: Number(window.App.urlVars().folioId || id),*/}
                  {/*                             unit_gross_amount: item.unit_gross_amount,*/}
                  {/*                             service: item?.service?.id,*/}
                  {/*                             quantity: item.quantity,*/}
                  {/*                             label: item.label,*/}
                  {/*                             vat_percent: item.vat_percent*/}
                  {/*                           }, {*/}
                  {/*                             params: {},*/}
                  {/*                             headers: {*/}
                  {/*                               'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
                  {/*                               "Sys-name": Cookies.get("instanceId"),*/}
                  {/*                               "Preferred-locale": Cookies.get("language")*/}
                  {/*                             }*/}
                  {/*                           })*/}
                  {/*                           .then(response => {*/}
                  {/*                             window.App.toastShow('success', t('success'), response.data.message)*/}
                  {/*                             if (index === ifasL) {*/}
                  {/*                               setLoadingPrices(true)*/}
                  {/*                             }*/}
                  {/*                           })*/}
                  {/*                           .catch(error => {*/}
                  {/*                             window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)*/}
                  {/*                           })*/}
                  {/*                       })*/}
                  {/*                     } else {*/}
                  {/*                       window.App.customToastShow('warn', t('warning'), t('no_ifa_calculated'));*/}
                  {/*                     }*/}
                  {/*                   })*/}
                  {/*                   .catch(error => {*/}
                  {/*                     setLoading(false)*/}
                  {/*                     //window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
                  {/*                     window.App.customToastShow('warn', t('warning'), error?.response?.data?.message)*/}
                  {/*                   })*/}
                  {/*               }}*/}
                  {/*               reject={() => {*/}
                  {/*                 window.App.setState({[`confirmDelete${id}`]: false})*/}
                  {/*               }}/>*/}
                </div>
              }
            </div>
            <table className={"w-100 p-datatable-table table-striped item-add-table"} cellPadding={0} cellSpacing={0}
                   border={0}>
              <tr>
                <th className={"p-p-2 p-text-nowrap p-text-left"}>{t('name')}</th>
                <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('quantity')}</th>
                <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('net_amount')}</th>
                <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('vat_percent')}</th>
                <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('gross_amount')}</th>
                <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('tot_price')}</th>
                <th></th>
              </tr>
              {items && items[0] &&
                <>
                  {items.map((item, index) => {
                    return (
                      <tr>
                        <td>
                          {item?.label &&
                            <span className={"p-d-block"}>
                            {item?.label}
                          </span>
                          }
                          {item?.service?.name &&
                            <span className={"p-d-block"}>
                              {item?.service?.name}
                            </span>
                          }
                        </td>
                        <td className={"p-text-right p-text-nowrap"}>
                          {formatQuantity(item?.quantity)} {item?.service?.unit || item?.unit}
                        </td>
                        <td className={"p-text-right p-text-nowrap"}>
                          {currencyFormatter.format(
                            item.unit_net_amount, {
                              precision: t('currency_precision'),
                              symbol: t('currency_symbol'),
                              decimal: t('currency_decimal'),
                              thousand: t('currency_thousand'),
                            }
                          )} {formData?.currency}
                        </td>
                        <td className={"p-text-right p-text-nowrap"}>
                          {item.vat_percent} %
                        </td>
                        <td className={"p-text-right p-text-nowrap p-text-bold"}>
                          {currencyFormatter.format(
                            item.unit_gross_amount, {
                              precision: t('currency_precision'),
                              symbol: t('currency_symbol'),
                              decimal: t('currency_decimal'),
                              thousand: t('currency_thousand'),
                            }
                          )} {formData?.currency}
                        </td>
                        <td className={"p-text-right p-text-nowrap p-text-bold"}>
                          {currencyFormatter.format(
                            item.gross_amount, {
                              precision: t('currency_precision'),
                              symbol: t('currency_symbol'),
                              decimal: t('currency_decimal'),
                              thousand: t('currency_thousand'),
                            }
                          )} {formData?.currency}
                        </td>
                        <td className={"p-text-right p-text-nowrap"}>
                          <Button type="button" aria-label={t('edit')}
                                  icon={"pi pi-pencil"}
                                  onClick={() => {
                                    setItemFormData({
                                      folio: id,
                                      ...item
                                    })
                                    let _params = '?'
                                    Object.entries(window.App.urlVars()).map(([key, value]) => {
                                      _params += key + '=' + value + '&'
                                    })
                                    _params += 'folioItemId=' + item.id
                                    if (window.location.href.includes('#/folio')) {
                                      navigate('/folio/' + action + '/' + id + '?folioItemId=' + item.id)
                                    }
                                    if (window.location.href.includes('#/customer')) {
                                      navigate('/customer/' + action + '/' + id + _params)
                                    }
                                    if (window.location.href.includes('#/calendar')) {
                                      navigate('/calendar/' + action + '/' + id + '?update=folio&folioId=' + window.App.urlVars().folioId + '&folioItemId=' + item.id)
                                    }
                                    if (window.location.href.includes('#/reservation')) {
                                      navigate('/reservation/' + action + '/' + id + '?update=folio&folioId=' + window.App.urlVars().folioId + '&folioItemId=' + item.id)
                                    }
                                    if (window.location.href.includes('#/control-panel')) {
                                      navigate('/control-panel?update=folio&folioId=' + window.App.urlVars().folioId + '&folioItemId=' + item.id)
                                    }
                                  }}
                                  className="p-button-warning p-button-sm p-ml-2"/>
                          <Button type="button" aria-label={t('delete')}
                                  icon={"pi pi-trash"}
                                  onClick={() => {
                                    setLoading(true)
                                    axios({
                                      method: 'delete',
                                      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio-item/" + item.id,
                                      params: {},
                                      headers: {
                                        'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                        "Sys-name": Cookies.get("instanceId"),
                                        "Preferred-locale": Cookies.get("language")
                                      }
                                    })
                                      .then(response => {
                                        window.App.toastShow('success', t('success'), response.data.message)
                                        setLoading(false)
                                        setLoadingPrices(true)
                                        window.App.setState({
                                          rerenderFolioForm: Math.random()
                                        })
                                      })
                                      .catch(error => {
                                        setLoading(false)
                                        window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                      })
                                    // let _items = items
                                    // _items.splice(index, 1)
                                    // setItems(_items)
                                    // setNewFormData({
                                    //   ...newFormData,
                                    //   items: _items
                                    // })
                                  }}
                                  className="p-button-danger p-button-sm p-ml-2"/>
                        </td>
                      </tr>
                    )
                  })}
                </>
              }
            </table>
            {formData.closed !== true &&
              <Fieldset
                className={"item-add p-mt-3"}
                legend={<span className={"item-add-legend"}><i className={"pi pi-plus"}></i><span>Új elem hozzáadása</span></span>}
              >
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-2 grid-col-label-input"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="service">{t('name')}</label>
                      <Dropdown  options={services}
                                filter
                                placeholder={t('service')}
                                optionLabel="name"
                                optionValue="id"
                                id={"service"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  let _service = services.filter(item => item.id === e.value)
                                  if (_service && _service[0] && _service[0].net_amount && _service[0].vat_group) {
                                    setItemFormData({
                                      ...itemFormData,
                                      label: _service[0].name,
                                      service: e.target.value,
                                      gross_amount: _service[0].gross_amount,
                                      net_amount: _service[0].net_amount,
                                      vat_percent: _service[0].vat_group.vat_percent,
                                      editable: _service[0].editable,
                                      unit: _service[0].unit,
                                    })
                                  } else {
                                    setItemFormData({
                                      ...itemFormData,
                                      label: _service[0].name,
                                      service: e.target.value,
                                      editable: _service[0].editable,
                                      unit: _service[0].unit,
                                    })
                                  }
                                }}
                                value={itemFormData.service}
                                className={"p-p-0"}
                      />
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-2 grid-col-label-input"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="quantity">{t('quantity')}</label>
                      <InputText id="quantity"
                                 keyfilter={"int"}
                                 style={{maxWidth: '70px'}}
                                 className={"p-inputtext-sm p-mr-2"}
                                 onChange={(e) => {
                                   setItemFormData({
                                     ...itemFormData,
                                     quantity: e.target.value
                                   })
                                 }}
                                 placeholder={t('quantity')}
                                 value={Math.floor(itemFormData.quantity || 0)}
                      />
                      <small className={"p-text-secondary"}>{itemFormData?.unit}</small>
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-2 grid-col-label-input"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="net_amount">{t('net_amount')}</label>
                      <InputText id="net_amount"
                                 className={"p-inputtext-sm"}
                                 value={`${currencyFormatter.format(
                                   itemFormData.net_amount, {
                                     precision: t('currency_precision'),
                                     symbol: t('currency_symbol'),
                                     decimal: t('currency_decimal'),
                                     thousand: t('currency_thousand'),
                                   }
                                 )} ${formData?.currency || ''}`.trim()}
                                 disabled
                      />
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-2 grid-col-label-input"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="vat_percent">{t('vat_percent')}</label>
                      <InputText id="vat_percent" className={"p-inputtext-sm"}
                                 value={`${itemFormData.vat_percent || 0} %`} disabled/>
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-2 grid-col-label-input"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="gross_amount">{t('gross_amount')}</label>
                      <InputText id="gross_amount"
                                 keyfilter={"int"}
                                 className={"p-inputtext-sm"}
                                 disabled={!itemFormData.editable}
                                 onChange={(e) => {
                                   setItemFormData({
                                     ...itemFormData,
                                     gross_amount: e.target.value
                                   })
                                 }}
                                 placeholder={t('gross_amount')}
                                 value={Math.round(itemFormData.gross_amount || 0)}
                      />
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-2 grid-col-label-input"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="tot_price">{t('tot_price')}</label>
                      <InputText
                        id="tot_price"
                        className={"p-inputtext-sm"}
                        value={`${currencyFormatter.format(
                          itemFormData.gross_amount * itemFormData.quantity, {
                            precision: t('currency_precision'),
                            symbol: t('currency_symbol'),
                            decimal: t('currency_decimal'),
                            thousand: t('currency_thousand'),
                          }
                        )} ${formData?.currency || ''}`.trim()}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-text-right"}>
                    <Button icon="pi pi-plus" className="p-button-sm p-button-success p-p-1"
                            label={t('save_new_item_label')}
                            tooltip={t('add')}
                            tooltipOptions={{position: 'left'}}
                            disabled={!itemFormData.service || !itemFormData.gross_amount || !itemFormData.quantity}
                            onClick={() => {
                              setLoading(true)
                              axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio-item",
                                {
                                  folio: Number(window.App.urlVars().folioId || id),
                                  unit_gross_amount: itemFormData.gross_amount,
                                  service: itemFormData.service,
                                  quantity: itemFormData.quantity,
                                }, {
                                  params: {},
                                  headers: {
                                    'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                    "Sys-name": Cookies.get("instanceId"),
                                    "Preferred-locale": Cookies.get("language")
                                  }
                                })
                                .then(response => {
                                  setItemFormData({
                                    ...itemFormData,
                                    gross_amount: null,
                                    service: null,
                                    quantity: 0,
                                  })
                                  setLoadingPrices(true)
                                  window.App.setState({
                                    rerenderFolioForm: Math.random(),
                                    rerenderFolioList: Math.random(),
                                  })
                                  window.App.toastShow('success', t('success'), response.data.message)
                                })
                                .catch(error => {
                                  setLoading(false)
                                  window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                })
                            }}
                    />
                  </div>
                </div>
              </Fieldset>
            }
            <Dialog header={t('edit_item')} visible={window.App.urlVars().folioItemId && itemFormData.id}
                    footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}}
                                                     severity="info" text={t("dialog_movable")}/></React.Fragment>}
                    onHide={() => {
                      setItemFormData({
                        folio: itemFormData?.folio?.id,
                        quantity: 0,
                      })
                      navigate(-1)
                    }} style={{minWidth: '980px', width: '980px', maxWidth: '980px'}} modal={false}>
              <Panel className={"p-mt-3"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="service">{t('service')}</label>
                      <span className="p-d-block">
                        <Dropdown  options={services}
                                  filter
                                  disabled={itemFormData.label}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"service"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    let _service = services.filter(item => item.id === e.value)
                                    if (_service && _service[0] && _service[0].gross_amount) {
                                      setItemFormData({
                                        ...itemFormData,
                                        service: e.target.value,
                                        gross_amount: _service[0].gross_amount
                                      })
                                    } else {
                                      setItemFormData({
                                        ...itemFormData,
                                        service: e.target.value
                                      })
                                    }
                                    setItemNewFormData({
                                      ...itemNewFormData,
                                      service: e.target.value,
                                    })
                                  }}
                                  value={itemFormData.service?.id || itemFormData.service}
                        />
                    </span>
                    </div>
                  </div>
                  {itemFormData.label &&
                    <div className={"p-col-12 p-lg-6"}>
                      <div className="p-field p-fluid">
                        <label htmlFor="label">{t('name')}</label>
                        <span className="p-d-block">
                        <InputText id="name"
                                   disabled={itemFormData.service}
                                   onChange={(e) => {
                                     setItemFormData({
                                       ...itemFormData,
                                       label: e.target.value
                                     })
                                     setItemNewFormData({
                                       ...itemNewFormData,
                                       label: e.target.value,
                                     })
                                   }}
                                   value={itemFormData.label}
                        />
                    </span>
                      </div>
                    </div>
                  }
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-2"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="quantity">{t('quantity')}</label>
                      <span className="p-d-block">
                        <InputText id="quantity"
                                   keyfilter={"int"}
                                   style={{maxWidth: '60px'}}
                                   className={"p-inputtext-sm"}
                                   onChange={(e) => {
                                     setItemFormData({
                                       ...itemFormData,
                                       quantity: e.target.value
                                     })
                                     setItemNewFormData({
                                       ...itemNewFormData,
                                       quantity: e.target.value,
                                     })
                                   }}
                                   value={Math.floor(itemFormData.quantity || 0)}
                        /> {itemFormData?.service?.unit}
                    </span>
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-3"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="unit_net_amount">{t('net_amount')}</label>
                      <span className="p-d-block p-mt-1">
                      {currencyFormatter.format(
                        itemFormData.unit_net_amount, {
                          precision: t('currency_precision'),
                          symbol: t('currency_symbol'),
                          decimal: t('currency_decimal'),
                          thousand: t('currency_thousand'),
                        }
                      )} {formData?.currency}
                    </span>
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-2"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="vat">{t('vat_percent')}</label>
                      <span className="p-d-block p-mt-1">
                      {itemFormData.vat_percent || '0'} %
                    </span>
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-3"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="gross_amount">{t('gross_amount')}</label>
                      <span className="p-d-block p-text-nowrap">
                        <InputText id="gross_amount"
                                   keyfilter={"int"}
                                   style={{maxWidth: '120px'}}
                                   className={"p-inputtext-sm"}
                                   onChange={(e) => {
                                     setItemFormData({
                                       ...itemFormData,
                                       unit_gross_amount: e.target.value
                                     })
                                     setItemNewFormData({
                                       ...itemNewFormData,
                                       unit_gross_amount: e.target.value,
                                     })
                                   }}
                                   value={Math.round(itemFormData.unit_gross_amount || 0)}
                        /> {formData?.currency}
                    </span>
                    </div>
                  </div>
                  <div className={"p-col-12 p-lg-2"}>
                    <div className="p-field p-fluid">
                      <label htmlFor="tot_price">{t('tot_price')}</label>
                      <span className="p-d-block p-mt-1">
                        {currencyFormatter.format(
                          itemFormData.unit_gross_amount * itemFormData.quantity, {
                            precision: t('currency_precision'),
                            symbol: t('currency_symbol'),
                            decimal: t('currency_decimal'),
                            thousand: t('currency_thousand'),
                          }
                        )} {formData?.currency}
                    </span>
                    </div>
                  </div>
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col"}>
                  </div>
                  <div className={"p-col p-text-right p-col-align-center"}>
                    <Button type="button" aria-label={t('save')} icon={"pi pi-save"}
                            label={t('save')}
                            loading={loading}
                            onClick={() => {
                              setLoading(true)
                              axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio-item/" + window.App.urlVars().folioItemId,
                                itemNewFormData, {
                                  params: {},
                                  headers: {
                                    'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                    "Sys-name": Cookies.get("instanceId"),
                                    "Preferred-locale": Cookies.get("language")
                                  }
                                })
                                .then(response => {
                                  setItemFormData({
                                    folio: itemFormData?.folio?.id,
                                    quantity: null,
                                  })
                                  window.App.toastShow('success', t('success'), response.data.message)
                                  setLoading(false)
                                  setLoadingPrices(true)
                                  setTimeout(() => {
                                    window.App.setState({
                                      rerenderFolioForm: Math.random(),
                                      rerenderFolioList: Math.random(),
                                    })
                                  }, 1000)
                                  navigate(-1)
                                })
                                .catch(error => {
                                  setLoading(false)
                                  window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                })
                            }}
                            className="p-button-success p-ml-2"/>
                  </div>
                </div>
              </Panel>
            </Dialog>
          </Panel>
        </BlockUI>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_FolioFormComponent);
